/**
 * 进度条
 * @params {百分比} point
 * @returns ProgressBar
 */
import { PureComponent, ReactNode } from "react";
import "./index.scss";

export default class ProgressBar extends PureComponent<any,any>{

  constructor(props:any){
    super(props);
    this.state = {

    }
  }
  // componentDidMount() {

  // }

  // componentDidUpdate() {

  // }

  render(): ReactNode {
    const {point} = this.props;
    return(<div className="progressBar">
      <div className="barBg">
        <div style={{width:`${Number(point)}%`}} className="barContent">
          <p>已完成{point}%</p>
        </div>
      </div>
    </div>)
  }
}
